export const APP_ASSET_KEY_PREFIX = 'asset.';
const ICON_PREFIX = 'asset.icon.';
const IMAGE_PREFIX = 'asset.image.';
export const APP_ASSET_MIN_BUILD = 179215738;
const ASSET_URL_PATTERN = /^https?:\/\/\S+$/;
export const APP_ASSET_URL_MAX_LENGTH = 1000;
export const APP_ICONS = [
    { name: 'AddToCart', multiColor: false },
    { name: 'AmericanExpress', multiColor: true },
    { name: 'AppDownloadQr', multiColor: true },
    { name: 'Apple', multiColor: true },
    { name: 'Arrange', multiColor: false },
    { name: 'ArrowDown', multiColor: false },
    { name: 'ArrowLeft', multiColor: false },
    { name: 'ArrowRight', multiColor: false },
    { name: 'ArrowUp', multiColor: false },
    { name: 'Auction', multiColor: false },
    { name: 'Badge', multiColor: false },
    { name: 'Bell', multiColor: false },
    { name: 'BellChecked', multiColor: false },
    { name: 'BellMuted', multiColor: false },
    { name: 'BellNotified', multiColor: false },
    { name: 'BellPlus', multiColor: false },
    { name: 'BoltbFull', multiColor: false },
    { name: 'Bronze', multiColor: true },
    { name: 'Camera', multiColor: false },
    { name: 'Chat', multiColor: false },
    { name: 'ChatNotified', multiColor: false },
    { name: 'CheckOff', multiColor: false },
    { name: 'CheckOn', multiColor: false },
    { name: 'Checked', multiColor: false },
    { name: 'ChevronDown', multiColor: false },
    { name: 'ChevronLeft', multiColor: false },
    { name: 'ChevronRight', multiColor: false },
    { name: 'ChevronUp', multiColor: false },
    { name: 'ClockFilled', multiColor: false },
    { name: 'ClockOutline', multiColor: false },
    { name: 'Close', multiColor: false },
    { name: 'CloseCircle', multiColor: false },
    { name: 'CloseSmall', multiColor: false },
    { name: 'Copy', multiColor: false },
    { name: 'Delete', multiColor: false },
    { name: 'Deny', multiColor: false },
    { name: 'DeviceCheckMark', multiColor: false },
    { name: 'DoubleChevron', multiColor: false },
    { name: 'Edit', multiColor: false },
    { name: 'EmptyBell', multiColor: true },
    { name: 'EmptyBox', multiColor: true },
    { name: 'EmptyMessage', multiColor: true },
    { name: 'EmptyOngoingLive', multiColor: true },
    { name: 'EmptyScheduledLive', multiColor: true },
    { name: 'ExternalLink', multiColor: false },
    { name: 'FailedPayment', multiColor: true },
    { name: 'Fb', multiColor: false },
    { name: 'Feather', multiColor: false },
    { name: 'File', multiColor: false },
    { name: 'Filter', multiColor: false },
    { name: 'GaPointer', multiColor: false },
    { name: 'Gift', multiColor: false },
    { name: 'Giveaway', multiColor: false },
    { name: 'Gold', multiColor: true },
    { name: 'Google', multiColor: true },
    { name: 'Hash', multiColor: false },
    { name: 'Heart', multiColor: false },
    { name: 'HeartFilled', multiColor: false },
    { name: 'Home', multiColor: false },
    { name: 'ImageOutline', multiColor: false },
    { name: 'Instagram', multiColor: false },
    { name: 'ItemSelling', multiColor: false },
    { name: 'Jcb', multiColor: true },
    { name: 'Kakao', multiColor: true },
    { name: 'LogOut', multiColor: false },
    { name: 'Make', multiColor: false },
    { name: 'Market', multiColor: false },
    { name: 'Mastercard', multiColor: true },
    { name: 'Memo', multiColor: false },
    { name: 'MemoDark', multiColor: false },
    { name: 'MemoEdit', multiColor: false },
    { name: 'MemoYellow', multiColor: true },
    { name: 'Menu', multiColor: false },
    { name: 'MicLine', multiColor: false },
    { name: 'MicOff', multiColor: false },
    { name: 'MicOn', multiColor: false },
    { name: 'Minus', multiColor: false },
    { name: 'MoreCircle', multiColor: false },
    { name: 'MoreHorizontal', multiColor: false },
    { name: 'MoreVertical', multiColor: false },
    { name: 'My', multiColor: false },
    { name: 'NewMessage', multiColor: false },
    { name: 'Notice', multiColor: false },
    { name: 'Package', multiColor: false },
    { name: 'PaymentCard', multiColor: false },
    { name: 'PinOutline', multiColor: false },
    { name: 'Play', multiColor: false },
    { name: 'Plus', multiColor: false },
    { name: 'PlusCircleAccent', multiColor: false },
    { name: 'PlusCircleFilled', multiColor: false },
    { name: 'Point', multiColor: false },
    { name: 'PriceTag', multiColor: false },
    { name: 'Pushpin', multiColor: false },
    { name: 'Repeat', multiColor: false },
    { name: 'Report', multiColor: false },
    { name: 'RotateCcw', multiColor: false },
    { name: 'Search', multiColor: false },
    { name: 'Send', multiColor: false },
    { name: 'Settings', multiColor: false },
    { name: 'Share', multiColor: false },
    { name: 'ShareOut', multiColor: false },
    { name: 'Silver', multiColor: true },
    { name: 'SoundOff', multiColor: false },
    { name: 'SoundOn', multiColor: false },
    { name: 'Successful', multiColor: false },
    { name: 'SuccessfulFilled', multiColor: false },
    { name: 'SwitchCamera', multiColor: false },
    { name: 'TikTok', multiColor: true },
    { name: 'ToggleOff', multiColor: true },
    { name: 'ToggleOn', multiColor: true },
    { name: 'Truck', multiColor: false },
    { name: 'TruckLine', multiColor: false },
    { name: 'User', multiColor: false },
    { name: 'UserX', multiColor: false },
    { name: 'Users', multiColor: false },
    { name: 'ViewerCount', multiColor: true },
    { name: 'Visa', multiColor: true },
    { name: 'VolumeOn', multiColor: false },
    { name: 'Wallet', multiColor: true },
    { name: 'WonCircle', multiColor: false },
    { name: 'X', multiColor: true },
    { name: 'Youtube', multiColor: false },
    { name: 'ZoomIn', multiColor: false },
];
export const APP_IMAGE_SLOTS = [
    {
        slot: 'paymentSuccessIllustration',
        label: '결제·카드 등록 완료 그림',
        usedAt: '결제 완료·카드 등록 완료·결제 인증 완료 화면',
    },
    {
        slot: 'broadcastDefaultBackground',
        label: '방송 기본 배경',
        usedAt: '썸네일 없는 방송 카드·방송 대기 화면·영상 전 화면',
    },
    {
        slot: 'homeFallbackBanner1',
        label: '홈 기본 배너 1',
        usedAt: '등록된 홈 배너가 하나도 없을 때 홈 배너',
    },
    {
        slot: 'homeFallbackBanner2',
        label: '홈 기본 배너 2',
        usedAt: '등록된 홈 배너가 하나도 없을 때 홈 배너',
    },
    {
        slot: 'homeFallbackBanner3',
        label: '홈 기본 배너 3',
        usedAt: '등록된 홈 배너가 하나도 없을 때 홈 배너',
    },
    {
        slot: 'homeFallbackBanner4',
        label: '홈 기본 배너 4',
        usedAt: '등록된 홈 배너가 하나도 없을 때 홈 배너',
    },
    {
        slot: 'desktopGooglePlayButton',
        label: 'PC 웹 Google Play 버튼',
        usedAt: 'PC로 연 모바일 웹 왼쪽 앱 내려받기',
    },
    {
        slot: 'desktopAppStoreButton',
        label: 'PC 웹 App Store 버튼',
        usedAt: 'PC로 연 모바일 웹 왼쪽 앱 내려받기',
    },
    {
        slot: 'kakaoShareThumbnail',
        label: '카카오톡 공유 썸네일',
        usedAt: '친구 초대 > 카카오톡 공유 카드 이미지(공개 주소 — 카카오가 내려받는다)',
    },
];
export const APP_KAKAO_SHARE_DEFAULT_IMAGE_URL = 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/1c/64/ee/1c64ee3e-1cc0-e23b-adda-1e5af41ac590/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/230x0w.webp';
const ICON_BY_NAME = new Map(APP_ICONS.map((icon) => [icon.name, icon]));
const IMAGE_BY_SLOT = new Map(APP_IMAGE_SLOTS.map((image) => [image.slot, image]));
export function findAppIcon(name) {
    return ICON_BY_NAME.get(name);
}
export function findAppImageSlot(slot) {
    return IMAGE_BY_SLOT.get(slot);
}
export function toAppIconSettingKey(name) {
    return `${ICON_PREFIX}${name}`;
}
export function toAppImageSettingKey(slot) {
    return `${IMAGE_PREFIX}${slot}`;
}
export function parseAppAssetSettingKey(key) {
    if (key.startsWith(ICON_PREFIX)) {
        const name = key.slice(ICON_PREFIX.length);
        return ICON_BY_NAME.has(name) ? { kind: 'icon', name } : null;
    }
    if (key.startsWith(IMAGE_PREFIX)) {
        const slot = key.slice(IMAGE_PREFIX.length);
        return IMAGE_BY_SLOT.has(slot) ? { kind: 'image', slot } : null;
    }
    return null;
}
export function isValidAppAssetValue(value) {
    return (typeof value === 'string' &&
        (value === '' || (value.length <= APP_ASSET_URL_MAX_LENGTH && ASSET_URL_PATTERN.test(value))));
}
export function resolveAppAssetOverrides(overrides) {
    const resolved = {};
    for (const [key, value] of Object.entries(overrides)) {
        if (parseAppAssetSettingKey(key) === null || !isValidAppAssetValue(value) || value === '')
            continue;
        resolved[key] = value;
    }
    return resolved;
}
//# sourceMappingURL=index.js.map